<div [formGroup]="form">
  <mat-form-field style="width:100%" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <textarea matInput rows="5" [formControlName]="controlName"
              [errorStateMatcher]="instantErrorMatcher" style="resize: none"></textarea>
    <mat-hint align="end" *ngIf="maxLength">
      {{ form.get(controlName).value?.length || 0 }}/{{ maxLength }}
    </mat-hint>
    <mat-error *ngIf="form.get(controlName).hasError('maxlength')">
      <i>{{ 'ERROR.MAX_LENGTH' | translate:{length: form.get(controlName).getError('maxlength').requiredLength} }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('minlength')">
      <i>{{ 'ERROR.MIN_LENGTH' | translate:{length: form.get(controlName).getError('minlength').requiredLength} }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('required')">
      <i>{{ 'ERROR.REQUIRED' | translate }}</i>
    </mat-error>
  </mat-form-field>
</div>
